// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/assessment_service.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Artifact } from "../../artifacts/v1/model_pb";
import { file_artifacts_v1_model } from "../../artifacts/v1/model_pb";
import type { AssessmentScore } from "../../assessment/v1/assessment_score_pb";
import { file_assessment_v1_assessment_score } from "../../assessment/v1/assessment_score_pb";
import type { User } from "../../customer/management/v1/service_pb";
import { file_customer_management_v1_service } from "../../customer/management/v1/service_pb";
import type { Duration, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { AssessmentDecision } from "./assessment_decision_pb";
import { file_inventory_v1_assessment_decision } from "./assessment_decision_pb";
import type { InherentRiskGroup } from "./company_service_pb";
import { file_inventory_v1_company_service } from "./company_service_pb";
import type { CompanySummary } from "./company_summary_pb";
import { file_inventory_v1_company_summary } from "./company_summary_pb";
import type { ControlCountStat, GetControlResponse, GetControlTimelineResponse, OldGetControlResponseV1, OldGetControlResponseV2 } from "./control_service_pb";
import { file_inventory_v1_control_service } from "./control_service_pb";
import type { GetFindingResponse, GetFindingTimelineResponse } from "./finding_legacy_pb";
import { file_inventory_v1_finding_legacy } from "./finding_legacy_pb";
import type { OngoingAssessment } from "./ongoing_assessment_pb";
import { file_inventory_v1_ongoing_assessment } from "./ongoing_assessment_pb";
import type { Project } from "./project_pb";
import { file_inventory_v1_project } from "./project_pb";
import type { RiskLevel } from "./risk_pb";
import { file_inventory_v1_risk } from "./risk_pb";
import type { Scope } from "./scope_pb";
import { file_inventory_v1_scope } from "./scope_pb";
import type { SignalType } from "./signal_pb";
import { file_inventory_v1_signal } from "./signal_pb";
import type { SignalDetail } from "./signal_detail_pb";
import { file_inventory_v1_signal_detail } from "./signal_detail_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/assessment_service.proto.
 */
export const file_inventory_v1_assessment_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_artifacts_v1_model, file_assessment_v1_assessment_score, file_customer_management_v1_service, file_google_protobuf_duration, file_google_protobuf_timestamp, file_inventory_v1_assessment_decision, file_inventory_v1_company_service, file_inventory_v1_company_summary, file_inventory_v1_control_service, file_inventory_v1_finding_legacy, file_inventory_v1_ongoing_assessment, file_inventory_v1_project, file_inventory_v1_risk, file_inventory_v1_scope, file_inventory_v1_signal, file_inventory_v1_signal_detail]);

/**
 * @generated from message inventory.v1.SubmitAssessmentForApprovalRequest
 */
export type SubmitAssessmentForApprovalRequest = Message<"inventory.v1.SubmitAssessmentForApprovalRequest"> & {
  /**
   * @generated from field: string ongoing_assessment_id = 1;
   */
  ongoingAssessmentId: string;
};

/**
 * Describes the message inventory.v1.SubmitAssessmentForApprovalRequest.
 * Use `create(SubmitAssessmentForApprovalRequestSchema)` to create a new message.
 */
export const SubmitAssessmentForApprovalRequestSchema: GenMessage<SubmitAssessmentForApprovalRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 0);

/**
 * @generated from message inventory.v1.SubmitAssessmentForApprovalResponse
 */
export type SubmitAssessmentForApprovalResponse = Message<"inventory.v1.SubmitAssessmentForApprovalResponse"> & {
};

/**
 * Describes the message inventory.v1.SubmitAssessmentForApprovalResponse.
 * Use `create(SubmitAssessmentForApprovalResponseSchema)` to create a new message.
 */
export const SubmitAssessmentForApprovalResponseSchema: GenMessage<SubmitAssessmentForApprovalResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 1);

/**
 * @generated from message inventory.v1.AddOngoingAssessmentAssigneeRequest
 */
export type AddOngoingAssessmentAssigneeRequest = Message<"inventory.v1.AddOngoingAssessmentAssigneeRequest"> & {
  /**
   * @generated from field: string ongoing_assessment_id = 1;
   */
  ongoingAssessmentId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;
};

/**
 * Describes the message inventory.v1.AddOngoingAssessmentAssigneeRequest.
 * Use `create(AddOngoingAssessmentAssigneeRequestSchema)` to create a new message.
 */
export const AddOngoingAssessmentAssigneeRequestSchema: GenMessage<AddOngoingAssessmentAssigneeRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 2);

/**
 * @generated from message inventory.v1.AddOngoingAssessmentAssigneeResponse
 */
export type AddOngoingAssessmentAssigneeResponse = Message<"inventory.v1.AddOngoingAssessmentAssigneeResponse"> & {
};

/**
 * Describes the message inventory.v1.AddOngoingAssessmentAssigneeResponse.
 * Use `create(AddOngoingAssessmentAssigneeResponseSchema)` to create a new message.
 */
export const AddOngoingAssessmentAssigneeResponseSchema: GenMessage<AddOngoingAssessmentAssigneeResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 3);

/**
 * @generated from message inventory.v1.RemoveOngoingAssessmentAssigneeRequest
 */
export type RemoveOngoingAssessmentAssigneeRequest = Message<"inventory.v1.RemoveOngoingAssessmentAssigneeRequest"> & {
  /**
   * @generated from field: string ongoing_assessment_id = 1;
   */
  ongoingAssessmentId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;
};

/**
 * Describes the message inventory.v1.RemoveOngoingAssessmentAssigneeRequest.
 * Use `create(RemoveOngoingAssessmentAssigneeRequestSchema)` to create a new message.
 */
export const RemoveOngoingAssessmentAssigneeRequestSchema: GenMessage<RemoveOngoingAssessmentAssigneeRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 4);

/**
 * @generated from message inventory.v1.RemoveOngoingAssessmentAssigneeResponse
 */
export type RemoveOngoingAssessmentAssigneeResponse = Message<"inventory.v1.RemoveOngoingAssessmentAssigneeResponse"> & {
};

/**
 * Describes the message inventory.v1.RemoveOngoingAssessmentAssigneeResponse.
 * Use `create(RemoveOngoingAssessmentAssigneeResponseSchema)` to create a new message.
 */
export const RemoveOngoingAssessmentAssigneeResponseSchema: GenMessage<RemoveOngoingAssessmentAssigneeResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 5);

/**
 * @generated from message inventory.v1.GetAssessmentNotesYdocRequest
 */
export type GetAssessmentNotesYdocRequest = Message<"inventory.v1.GetAssessmentNotesYdocRequest"> & {
  /**
   * @generated from field: string assessment_id = 1;
   */
  assessmentId: string;
};

/**
 * Describes the message inventory.v1.GetAssessmentNotesYdocRequest.
 * Use `create(GetAssessmentNotesYdocRequestSchema)` to create a new message.
 */
export const GetAssessmentNotesYdocRequestSchema: GenMessage<GetAssessmentNotesYdocRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 6);

/**
 * @generated from message inventory.v1.GetAssessmentNotesYdocResponse
 */
export type GetAssessmentNotesYdocResponse = Message<"inventory.v1.GetAssessmentNotesYdocResponse"> & {
  /**
   * @generated from field: bytes notes_ydoc = 1;
   */
  notesYdoc: Uint8Array;
};

/**
 * Describes the message inventory.v1.GetAssessmentNotesYdocResponse.
 * Use `create(GetAssessmentNotesYdocResponseSchema)` to create a new message.
 */
export const GetAssessmentNotesYdocResponseSchema: GenMessage<GetAssessmentNotesYdocResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 7);

/**
 * @generated from message inventory.v1.DeleteOngoingAssessmentRequest
 */
export type DeleteOngoingAssessmentRequest = Message<"inventory.v1.DeleteOngoingAssessmentRequest"> & {
  /**
   * @generated from field: string ongoing_assessment_id = 1;
   */
  ongoingAssessmentId: string;
};

/**
 * Describes the message inventory.v1.DeleteOngoingAssessmentRequest.
 * Use `create(DeleteOngoingAssessmentRequestSchema)` to create a new message.
 */
export const DeleteOngoingAssessmentRequestSchema: GenMessage<DeleteOngoingAssessmentRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 8);

/**
 * @generated from message inventory.v1.DeleteOngoingAssessmentResponse
 */
export type DeleteOngoingAssessmentResponse = Message<"inventory.v1.DeleteOngoingAssessmentResponse"> & {
};

/**
 * Describes the message inventory.v1.DeleteOngoingAssessmentResponse.
 * Use `create(DeleteOngoingAssessmentResponseSchema)` to create a new message.
 */
export const DeleteOngoingAssessmentResponseSchema: GenMessage<DeleteOngoingAssessmentResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 9);

/**
 * @generated from message inventory.v1.UpdateAssessmentDueDateRequest
 */
export type UpdateAssessmentDueDateRequest = Message<"inventory.v1.UpdateAssessmentDueDateRequest"> & {
  /**
   * @generated from field: string assessment_id = 1;
   */
  assessmentId: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp due_date = 2;
   */
  dueDate?: Timestamp;
};

/**
 * Describes the message inventory.v1.UpdateAssessmentDueDateRequest.
 * Use `create(UpdateAssessmentDueDateRequestSchema)` to create a new message.
 */
export const UpdateAssessmentDueDateRequestSchema: GenMessage<UpdateAssessmentDueDateRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 10);

/**
 * @generated from message inventory.v1.UpdateAssessmentDueDateResponse
 */
export type UpdateAssessmentDueDateResponse = Message<"inventory.v1.UpdateAssessmentDueDateResponse"> & {
};

/**
 * Describes the message inventory.v1.UpdateAssessmentDueDateResponse.
 * Use `create(UpdateAssessmentDueDateResponseSchema)` to create a new message.
 */
export const UpdateAssessmentDueDateResponseSchema: GenMessage<UpdateAssessmentDueDateResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 11);

/**
 * @generated from message inventory.v1.ListAssessmentCadenceSettingsRequest
 */
export type ListAssessmentCadenceSettingsRequest = Message<"inventory.v1.ListAssessmentCadenceSettingsRequest"> & {
};

/**
 * Describes the message inventory.v1.ListAssessmentCadenceSettingsRequest.
 * Use `create(ListAssessmentCadenceSettingsRequestSchema)` to create a new message.
 */
export const ListAssessmentCadenceSettingsRequestSchema: GenMessage<ListAssessmentCadenceSettingsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 12);

/**
 * @generated from message inventory.v1.ListAssessmentCadenceSettingsResponse
 */
export type ListAssessmentCadenceSettingsResponse = Message<"inventory.v1.ListAssessmentCadenceSettingsResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.AssessmentCadenceSetting settings = 1;
   */
  settings: AssessmentCadenceSetting[];
};

/**
 * Describes the message inventory.v1.ListAssessmentCadenceSettingsResponse.
 * Use `create(ListAssessmentCadenceSettingsResponseSchema)` to create a new message.
 */
export const ListAssessmentCadenceSettingsResponseSchema: GenMessage<ListAssessmentCadenceSettingsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 13);

/**
 * @generated from message inventory.v1.AssessmentCadenceSetting
 */
export type AssessmentCadenceSetting = Message<"inventory.v1.AssessmentCadenceSetting"> & {
  /**
   * @generated from field: inventory.v1.RiskLevel risk_level = 1;
   */
  riskLevel: RiskLevel;

  /**
   * @generated from field: optional google.protobuf.Duration cadence = 2;
   */
  cadence?: Duration;
};

/**
 * Describes the message inventory.v1.AssessmentCadenceSetting.
 * Use `create(AssessmentCadenceSettingSchema)` to create a new message.
 */
export const AssessmentCadenceSettingSchema: GenMessage<AssessmentCadenceSetting> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 14);

/**
 * @generated from message inventory.v1.SetAssessmentCadenceSettingRequest
 */
export type SetAssessmentCadenceSettingRequest = Message<"inventory.v1.SetAssessmentCadenceSettingRequest"> & {
  /**
   * @generated from field: inventory.v1.RiskLevel risk_level = 1;
   */
  riskLevel: RiskLevel;

  /**
   * @generated from field: optional google.protobuf.Duration cadence = 2;
   */
  cadence?: Duration;
};

/**
 * Describes the message inventory.v1.SetAssessmentCadenceSettingRequest.
 * Use `create(SetAssessmentCadenceSettingRequestSchema)` to create a new message.
 */
export const SetAssessmentCadenceSettingRequestSchema: GenMessage<SetAssessmentCadenceSettingRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 15);

/**
 * @generated from message inventory.v1.SetAssessmentCadenceSettingResponse
 */
export type SetAssessmentCadenceSettingResponse = Message<"inventory.v1.SetAssessmentCadenceSettingResponse"> & {
};

/**
 * Describes the message inventory.v1.SetAssessmentCadenceSettingResponse.
 * Use `create(SetAssessmentCadenceSettingResponseSchema)` to create a new message.
 */
export const SetAssessmentCadenceSettingResponseSchema: GenMessage<SetAssessmentCadenceSettingResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 16);

/**
 * @generated from message inventory.v1.AssessmentScoreLabel
 */
export type AssessmentScoreLabel = Message<"inventory.v1.AssessmentScoreLabel"> & {
  /**
   * @generated from field: assessment.v1.AssessmentScore score = 1;
   */
  score: AssessmentScore;

  /**
   * @generated from field: string label = 2;
   */
  label: string;
};

/**
 * Describes the message inventory.v1.AssessmentScoreLabel.
 * Use `create(AssessmentScoreLabelSchema)` to create a new message.
 */
export const AssessmentScoreLabelSchema: GenMessage<AssessmentScoreLabel> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 17);

/**
 * @generated from message inventory.v1.ListAssessmentScoreLabelsRequest
 */
export type ListAssessmentScoreLabelsRequest = Message<"inventory.v1.ListAssessmentScoreLabelsRequest"> & {
};

/**
 * Describes the message inventory.v1.ListAssessmentScoreLabelsRequest.
 * Use `create(ListAssessmentScoreLabelsRequestSchema)` to create a new message.
 */
export const ListAssessmentScoreLabelsRequestSchema: GenMessage<ListAssessmentScoreLabelsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 18);

/**
 * @generated from message inventory.v1.ListAssessmentScoreLabelsResponse
 */
export type ListAssessmentScoreLabelsResponse = Message<"inventory.v1.ListAssessmentScoreLabelsResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.AssessmentScoreLabel labels = 1;
   */
  labels: AssessmentScoreLabel[];
};

/**
 * Describes the message inventory.v1.ListAssessmentScoreLabelsResponse.
 * Use `create(ListAssessmentScoreLabelsResponseSchema)` to create a new message.
 */
export const ListAssessmentScoreLabelsResponseSchema: GenMessage<ListAssessmentScoreLabelsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 19);

/**
 * @generated from message inventory.v1.SetAssessmentScoreLabelsRequest
 */
export type SetAssessmentScoreLabelsRequest = Message<"inventory.v1.SetAssessmentScoreLabelsRequest"> & {
  /**
   * @generated from field: repeated inventory.v1.AssessmentScoreLabel labels = 1;
   */
  labels: AssessmentScoreLabel[];
};

/**
 * Describes the message inventory.v1.SetAssessmentScoreLabelsRequest.
 * Use `create(SetAssessmentScoreLabelsRequestSchema)` to create a new message.
 */
export const SetAssessmentScoreLabelsRequestSchema: GenMessage<SetAssessmentScoreLabelsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 20);

/**
 * @generated from message inventory.v1.SetAssessmentScoreLabelsResponse
 */
export type SetAssessmentScoreLabelsResponse = Message<"inventory.v1.SetAssessmentScoreLabelsResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.AssessmentScoreLabel labels = 1;
   */
  labels: AssessmentScoreLabel[];
};

/**
 * Describes the message inventory.v1.SetAssessmentScoreLabelsResponse.
 * Use `create(SetAssessmentScoreLabelsResponseSchema)` to create a new message.
 */
export const SetAssessmentScoreLabelsResponseSchema: GenMessage<SetAssessmentScoreLabelsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 21);

/**
 * @generated from message inventory.v1.DeleteAssessmentScoreLabelsRequest
 */
export type DeleteAssessmentScoreLabelsRequest = Message<"inventory.v1.DeleteAssessmentScoreLabelsRequest"> & {
};

/**
 * Describes the message inventory.v1.DeleteAssessmentScoreLabelsRequest.
 * Use `create(DeleteAssessmentScoreLabelsRequestSchema)` to create a new message.
 */
export const DeleteAssessmentScoreLabelsRequestSchema: GenMessage<DeleteAssessmentScoreLabelsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 22);

/**
 * @generated from message inventory.v1.DeleteAssessmentScoreLabelsResponse
 */
export type DeleteAssessmentScoreLabelsResponse = Message<"inventory.v1.DeleteAssessmentScoreLabelsResponse"> & {
};

/**
 * Describes the message inventory.v1.DeleteAssessmentScoreLabelsResponse.
 * Use `create(DeleteAssessmentScoreLabelsResponseSchema)` to create a new message.
 */
export const DeleteAssessmentScoreLabelsResponseSchema: GenMessage<DeleteAssessmentScoreLabelsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 23);

/**
 * @generated from message inventory.v1.GetOngoingAssessmentRequest
 */
export type GetOngoingAssessmentRequest = Message<"inventory.v1.GetOngoingAssessmentRequest"> & {
  /**
   * @generated from field: string ongoing_assessment_id = 1;
   */
  ongoingAssessmentId: string;
};

/**
 * Describes the message inventory.v1.GetOngoingAssessmentRequest.
 * Use `create(GetOngoingAssessmentRequestSchema)` to create a new message.
 */
export const GetOngoingAssessmentRequestSchema: GenMessage<GetOngoingAssessmentRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 24);

/**
 * @generated from message inventory.v1.GetOngoingAssessmentResponse
 */
export type GetOngoingAssessmentResponse = Message<"inventory.v1.GetOngoingAssessmentResponse"> & {
  /**
   * @generated from field: inventory.v1.OngoingAssessment ongoing_assessment = 1;
   */
  ongoingAssessment?: OngoingAssessment;
};

/**
 * Describes the message inventory.v1.GetOngoingAssessmentResponse.
 * Use `create(GetOngoingAssessmentResponseSchema)` to create a new message.
 */
export const GetOngoingAssessmentResponseSchema: GenMessage<GetOngoingAssessmentResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 25);

/**
 * @generated from message inventory.v1.ListOngoingAssessmentsRequest
 */
export type ListOngoingAssessmentsRequest = Message<"inventory.v1.ListOngoingAssessmentsRequest"> & {
  /**
   * @generated from field: optional string company_id = 1;
   */
  companyId?: string;
};

/**
 * Describes the message inventory.v1.ListOngoingAssessmentsRequest.
 * Use `create(ListOngoingAssessmentsRequestSchema)` to create a new message.
 */
export const ListOngoingAssessmentsRequestSchema: GenMessage<ListOngoingAssessmentsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 26);

/**
 * @generated from message inventory.v1.ListOngoingAssessmentsResponse
 */
export type ListOngoingAssessmentsResponse = Message<"inventory.v1.ListOngoingAssessmentsResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.OngoingAssessment ongoing_assessments = 1;
   */
  ongoingAssessments: OngoingAssessment[];
};

/**
 * Describes the message inventory.v1.ListOngoingAssessmentsResponse.
 * Use `create(ListOngoingAssessmentsResponseSchema)` to create a new message.
 */
export const ListOngoingAssessmentsResponseSchema: GenMessage<ListOngoingAssessmentsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 27);

/**
 * @generated from message inventory.v1.StartAssessmentRequest
 */
export type StartAssessmentRequest = Message<"inventory.v1.StartAssessmentRequest"> & {
  /**
   * @generated from field: string company_id = 1;
   */
  companyId: string;

  /**
   * @generated from field: optional string project_id = 2;
   */
  projectId?: string;

  /**
   * @generated from field: bool start_as_in_progress = 3;
   */
  startAsInProgress: boolean;

  /**
   * In case the assessment is ready to start and the user want to start it
   *
   * @generated from field: optional string ongoing_assessment_id = 4;
   */
  ongoingAssessmentId?: string;

  /**
   * OrgProcurementRequest.ID — when set, links the new assessment to the originating
   * approved procurement request so outbound webhooks can include the request's
   * external_request_id in their payloads. Left null when not provided.
   *
   * @generated from field: optional string request_id = 5;
   */
  requestId?: string;
};

/**
 * Describes the message inventory.v1.StartAssessmentRequest.
 * Use `create(StartAssessmentRequestSchema)` to create a new message.
 */
export const StartAssessmentRequestSchema: GenMessage<StartAssessmentRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 28);

/**
 * @generated from message inventory.v1.StartAssessmentResponse
 */
export type StartAssessmentResponse = Message<"inventory.v1.StartAssessmentResponse"> & {
  /**
   * @generated from field: string ongoing_assessment_id = 1;
   */
  ongoingAssessmentId: string;
};

/**
 * Describes the message inventory.v1.StartAssessmentResponse.
 * Use `create(StartAssessmentResponseSchema)` to create a new message.
 */
export const StartAssessmentResponseSchema: GenMessage<StartAssessmentResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 29);

/**
 * @generated from message inventory.v1.SetProjectControlScopeRequest
 */
export type SetProjectControlScopeRequest = Message<"inventory.v1.SetProjectControlScopeRequest"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string scope_id = 2;
   */
  scopeId: string;

  /**
   * @generated from field: inventory.v1.ProjectAttributeChangeType change_type = 3;
   */
  changeType: ProjectAttributeChangeType;
};

/**
 * Describes the message inventory.v1.SetProjectControlScopeRequest.
 * Use `create(SetProjectControlScopeRequestSchema)` to create a new message.
 */
export const SetProjectControlScopeRequestSchema: GenMessage<SetProjectControlScopeRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 30);

/**
 * @generated from message inventory.v1.SetProjectControlScopeResponse
 */
export type SetProjectControlScopeResponse = Message<"inventory.v1.SetProjectControlScopeResponse"> & {
};

/**
 * Describes the message inventory.v1.SetProjectControlScopeResponse.
 * Use `create(SetProjectControlScopeResponseSchema)` to create a new message.
 */
export const SetProjectControlScopeResponseSchema: GenMessage<SetProjectControlScopeResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 31);

/**
 * @generated from message inventory.v1.SetProjectMemberRequest
 */
export type SetProjectMemberRequest = Message<"inventory.v1.SetProjectMemberRequest"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: inventory.v1.ProjectAttributeChangeType change_type = 3;
   */
  changeType: ProjectAttributeChangeType;
};

/**
 * Describes the message inventory.v1.SetProjectMemberRequest.
 * Use `create(SetProjectMemberRequestSchema)` to create a new message.
 */
export const SetProjectMemberRequestSchema: GenMessage<SetProjectMemberRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 32);

/**
 * @generated from message inventory.v1.SetProjectMemberResponse
 */
export type SetProjectMemberResponse = Message<"inventory.v1.SetProjectMemberResponse"> & {
};

/**
 * Describes the message inventory.v1.SetProjectMemberResponse.
 * Use `create(SetProjectMemberResponseSchema)` to create a new message.
 */
export const SetProjectMemberResponseSchema: GenMessage<SetProjectMemberResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 33);

/**
 * @generated from message inventory.v1.RemoveProjectMemberRequest
 */
export type RemoveProjectMemberRequest = Message<"inventory.v1.RemoveProjectMemberRequest"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;
};

/**
 * Describes the message inventory.v1.RemoveProjectMemberRequest.
 * Use `create(RemoveProjectMemberRequestSchema)` to create a new message.
 */
export const RemoveProjectMemberRequestSchema: GenMessage<RemoveProjectMemberRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 34);

/**
 * @generated from message inventory.v1.RemoveProjectMemberResponse
 */
export type RemoveProjectMemberResponse = Message<"inventory.v1.RemoveProjectMemberResponse"> & {
};

/**
 * Describes the message inventory.v1.RemoveProjectMemberResponse.
 * Use `create(RemoveProjectMemberResponseSchema)` to create a new message.
 */
export const RemoveProjectMemberResponseSchema: GenMessage<RemoveProjectMemberResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 35);

/**
 * @generated from message inventory.v1.UpdateProjectNameRequest
 */
export type UpdateProjectNameRequest = Message<"inventory.v1.UpdateProjectNameRequest"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string new_name = 2;
   */
  newName: string;
};

/**
 * Describes the message inventory.v1.UpdateProjectNameRequest.
 * Use `create(UpdateProjectNameRequestSchema)` to create a new message.
 */
export const UpdateProjectNameRequestSchema: GenMessage<UpdateProjectNameRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 36);

/**
 * @generated from message inventory.v1.UpdateProjectNameResponse
 */
export type UpdateProjectNameResponse = Message<"inventory.v1.UpdateProjectNameResponse"> & {
};

/**
 * Describes the message inventory.v1.UpdateProjectNameResponse.
 * Use `create(UpdateProjectNameResponseSchema)` to create a new message.
 */
export const UpdateProjectNameResponseSchema: GenMessage<UpdateProjectNameResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 37);

/**
 * @generated from message inventory.v1.CreateProjectRequest
 */
export type CreateProjectRequest = Message<"inventory.v1.CreateProjectRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message inventory.v1.CreateProjectRequest.
 * Use `create(CreateProjectRequestSchema)` to create a new message.
 */
export const CreateProjectRequestSchema: GenMessage<CreateProjectRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 38);

/**
 * @generated from message inventory.v1.CreateProjectResponse
 */
export type CreateProjectResponse = Message<"inventory.v1.CreateProjectResponse"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;
};

/**
 * Describes the message inventory.v1.CreateProjectResponse.
 * Use `create(CreateProjectResponseSchema)` to create a new message.
 */
export const CreateProjectResponseSchema: GenMessage<CreateProjectResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 39);

/**
 * @generated from message inventory.v1.DeleteProjectRequest
 */
export type DeleteProjectRequest = Message<"inventory.v1.DeleteProjectRequest"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;
};

/**
 * Describes the message inventory.v1.DeleteProjectRequest.
 * Use `create(DeleteProjectRequestSchema)` to create a new message.
 */
export const DeleteProjectRequestSchema: GenMessage<DeleteProjectRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 40);

/**
 * @generated from message inventory.v1.DeleteProjectResponse
 */
export type DeleteProjectResponse = Message<"inventory.v1.DeleteProjectResponse"> & {
};

/**
 * Describes the message inventory.v1.DeleteProjectResponse.
 * Use `create(DeleteProjectResponseSchema)` to create a new message.
 */
export const DeleteProjectResponseSchema: GenMessage<DeleteProjectResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 41);

/**
 * @generated from message inventory.v1.ListProjectsRequest
 */
export type ListProjectsRequest = Message<"inventory.v1.ListProjectsRequest"> & {
  /**
   * @generated from field: bool with_deleted = 1;
   */
  withDeleted: boolean;
};

/**
 * Describes the message inventory.v1.ListProjectsRequest.
 * Use `create(ListProjectsRequestSchema)` to create a new message.
 */
export const ListProjectsRequestSchema: GenMessage<ListProjectsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 42);

/**
 * @generated from message inventory.v1.ListProjectsResponse
 */
export type ListProjectsResponse = Message<"inventory.v1.ListProjectsResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.Project projects = 1;
   */
  projects: Project[];
};

/**
 * Describes the message inventory.v1.ListProjectsResponse.
 * Use `create(ListProjectsResponseSchema)` to create a new message.
 */
export const ListProjectsResponseSchema: GenMessage<ListProjectsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 43);

/**
 * @generated from message inventory.v1.GetProjectRequest
 */
export type GetProjectRequest = Message<"inventory.v1.GetProjectRequest"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;
};

/**
 * Describes the message inventory.v1.GetProjectRequest.
 * Use `create(GetProjectRequestSchema)` to create a new message.
 */
export const GetProjectRequestSchema: GenMessage<GetProjectRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 44);

/**
 * @generated from message inventory.v1.GetProjectResponse
 */
export type GetProjectResponse = Message<"inventory.v1.GetProjectResponse"> & {
  /**
   * @generated from field: inventory.v1.Project project = 1;
   */
  project?: Project;

  /**
   * @generated from field: repeated inventory.v1.Scope control_scopes = 2;
   */
  controlScopes: Scope[];
};

/**
 * Describes the message inventory.v1.GetProjectResponse.
 * Use `create(GetProjectResponseSchema)` to create a new message.
 */
export const GetProjectResponseSchema: GenMessage<GetProjectResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 45);

/**
 * @generated from message inventory.v1.FinalizeAssessmentRequest
 */
export type FinalizeAssessmentRequest = Message<"inventory.v1.FinalizeAssessmentRequest"> & {
  /**
   * @generated from field: string company_id = 1;
   */
  companyId: string;

  /**
   * @generated from field: inventory.v1.AssessmentDecision decision = 2;
   */
  decision: AssessmentDecision;

  /**
   * @generated from field: string assessment_id = 3;
   */
  assessmentId: string;
};

/**
 * Describes the message inventory.v1.FinalizeAssessmentRequest.
 * Use `create(FinalizeAssessmentRequestSchema)` to create a new message.
 */
export const FinalizeAssessmentRequestSchema: GenMessage<FinalizeAssessmentRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 46);

/**
 * @generated from message inventory.v1.FinalizeAssessmentResponse
 */
export type FinalizeAssessmentResponse = Message<"inventory.v1.FinalizeAssessmentResponse"> & {
  /**
   * @generated from field: bool has_rejected_assessment = 1;
   */
  hasRejectedAssessment: boolean;

  /**
   * @generated from field: bool is_final_assessment = 2;
   */
  isFinalAssessment: boolean;

  /**
   * @generated from field: string past_assessment_id = 3;
   */
  pastAssessmentId: string;
};

/**
 * Describes the message inventory.v1.FinalizeAssessmentResponse.
 * Use `create(FinalizeAssessmentResponseSchema)` to create a new message.
 */
export const FinalizeAssessmentResponseSchema: GenMessage<FinalizeAssessmentResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 47);

/**
 * @generated from message inventory.v1.ListAssessmentsRequest
 */
export type ListAssessmentsRequest = Message<"inventory.v1.ListAssessmentsRequest"> & {
  /**
   * @generated from field: optional string company_id = 1;
   */
  companyId?: string;
};

/**
 * Describes the message inventory.v1.ListAssessmentsRequest.
 * Use `create(ListAssessmentsRequestSchema)` to create a new message.
 */
export const ListAssessmentsRequestSchema: GenMessage<ListAssessmentsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 48);

/**
 * @generated from message inventory.v1.ListAssessmentsResponse
 */
export type ListAssessmentsResponse = Message<"inventory.v1.ListAssessmentsResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.AssessmentInfo assessments = 1;
   */
  assessments: AssessmentInfo[];
};

/**
 * Describes the message inventory.v1.ListAssessmentsResponse.
 * Use `create(ListAssessmentsResponseSchema)` to create a new message.
 */
export const ListAssessmentsResponseSchema: GenMessage<ListAssessmentsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 49);

/**
 * @generated from message inventory.v1.GetAssessmentRequest
 */
export type GetAssessmentRequest = Message<"inventory.v1.GetAssessmentRequest"> & {
  /**
   * @generated from field: string assessment_id = 1;
   */
  assessmentId: string;
};

/**
 * Describes the message inventory.v1.GetAssessmentRequest.
 * Use `create(GetAssessmentRequestSchema)` to create a new message.
 */
export const GetAssessmentRequestSchema: GenMessage<GetAssessmentRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 50);

/**
 * @generated from message inventory.v1.GetAssessmentResponse
 */
export type GetAssessmentResponse = Message<"inventory.v1.GetAssessmentResponse"> & {
  /**
   * @generated from field: inventory.v1.VersionedAssessment assessment = 1;
   */
  assessment?: VersionedAssessment;
};

/**
 * Describes the message inventory.v1.GetAssessmentResponse.
 * Use `create(GetAssessmentResponseSchema)` to create a new message.
 */
export const GetAssessmentResponseSchema: GenMessage<GetAssessmentResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 51);

/**
 * @generated from message inventory.v1.AssessmentInfo
 */
export type AssessmentInfo = Message<"inventory.v1.AssessmentInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string version = 2;
   */
  version: string;

  /**
   * @generated from field: inventory.v1.RiskLevel risk_level = 3;
   */
  riskLevel: RiskLevel;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: inventory.v1.AssessmentDecision decision = 5;
   */
  decision: AssessmentDecision;

  /**
   * @generated from field: repeated customer.management.v1.User authors = 6;
   */
  authors: User[];

  /**
   * @generated from field: repeated inventory.v1.ControlCountStat controls_by_status = 8;
   */
  controlsByStatus: ControlCountStat[];

  /**
   * @generated from field: string company_id = 9;
   */
  companyId: string;

  /**
   * @generated from field: bytes notes_ydoc = 10;
   */
  notesYdoc: Uint8Array;

  /**
   * @generated from field: optional string project_name = 11;
   */
  projectName?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp due_date = 12;
   */
  dueDate?: Timestamp;

  /**
   * @generated from field: assessment.v1.AssessmentScore score = 13;
   */
  score: AssessmentScore;

  /**
   * @generated from field: google.protobuf.Timestamp started_at = 14;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp completed_at = 15;
   */
  completedAt?: Timestamp;

  /**
   * @generated from field: optional customer.management.v1.User concluded_by = 16;
   */
  concludedBy?: User;

  /**
   * @generated from field: optional google.protobuf.Timestamp concluded_at = 17;
   */
  concludedAt?: Timestamp;

  /**
   * @generated from field: optional string ongoing_assessment_id = 18;
   */
  ongoingAssessmentId?: string;

  /**
   * @generated from field: repeated customer.management.v1.User assignees = 19;
   */
  assignees: User[];
};

/**
 * Describes the message inventory.v1.AssessmentInfo.
 * Use `create(AssessmentInfoSchema)` to create a new message.
 */
export const AssessmentInfoSchema: GenMessage<AssessmentInfo> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 52);

/**
 * @generated from message inventory.v1.VersionedAssessment
 */
export type VersionedAssessment = Message<"inventory.v1.VersionedAssessment"> & {
  /**
   * @generated from oneof inventory.v1.VersionedAssessment.assessment
   */
  assessment: {
    /**
     * @generated from field: inventory.v1.Assessment assessment_v4 = 4;
     */
    value: Assessment;
    case: "assessmentV4";
  } | {
    /**
     * @generated from field: inventory.v1.OldAssessmentV3 assessment_v3 = 3;
     */
    value: OldAssessmentV3;
    case: "assessmentV3";
  } | {
    /**
     * @generated from field: inventory.v1.OldAssessmentV2 assessment_v2 = 1;
     */
    value: OldAssessmentV2;
    case: "assessmentV2";
  } | {
    /**
     * @generated from field: inventory.v1.OldAssessmentV1 assessment_v1 = 2;
     */
    value: OldAssessmentV1;
    case: "assessmentV1";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message inventory.v1.VersionedAssessment.
 * Use `create(VersionedAssessmentSchema)` to create a new message.
 */
export const VersionedAssessmentSchema: GenMessage<VersionedAssessment> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 53);

/**
 * Assessment is the current (v4) shape. Per convention, the latest version
 * of the message is named `Assessment` (no suffix); older shapes keep
 * `OldAssessmentVN` names. assessment_signals replaces the v3
 * assessment_findings per the ENG-2978 Signal/Alert migration.
 *
 * @generated from message inventory.v1.Assessment
 */
export type Assessment = Message<"inventory.v1.Assessment"> & {
  /**
   * @generated from field: inventory.v1.AssessmentInfo info = 1;
   */
  info?: AssessmentInfo;

  /**
   * @generated from field: repeated inventory.v1.AssessmentSignal assessment_signals = 2;
   */
  assessmentSignals: AssessmentSignal[];

  /**
   * @generated from field: repeated inventory.v1.AssessmentControl assessment_controls = 3;
   */
  assessmentControls: AssessmentControl[];

  /**
   * @generated from field: repeated artifacts.v1.Artifact artifacts = 4;
   */
  artifacts: Artifact[];

  /**
   * @generated from field: repeated inventory.v1.InherentRiskGroup inherent_risk_groups = 5;
   */
  inherentRiskGroups: InherentRiskGroup[];
};

/**
 * Describes the message inventory.v1.Assessment.
 * Use `create(AssessmentSchema)` to create a new message.
 */
export const AssessmentSchema: GenMessage<Assessment> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 54);

/**
 * OldAssessmentV3 is the legacy v3 shape (finding-based, matches main pre
 * ENG-2978). Kept so existing v3 rows in the DB stay readable.
 *
 * @generated from message inventory.v1.OldAssessmentV3
 */
export type OldAssessmentV3 = Message<"inventory.v1.OldAssessmentV3"> & {
  /**
   * @generated from field: inventory.v1.AssessmentInfo info = 1;
   */
  info?: AssessmentInfo;

  /**
   * @generated from field: repeated inventory.v1.AssessmentFinding assessment_findings = 2;
   */
  assessmentFindings: AssessmentFinding[];

  /**
   * @generated from field: repeated inventory.v1.AssessmentControl assessment_controls = 3;
   */
  assessmentControls: AssessmentControl[];

  /**
   * @generated from field: repeated artifacts.v1.Artifact artifacts = 4;
   */
  artifacts: Artifact[];

  /**
   * @generated from field: repeated inventory.v1.InherentRiskGroup inherent_risk_groups = 5;
   */
  inherentRiskGroups: InherentRiskGroup[];
};

/**
 * Describes the message inventory.v1.OldAssessmentV3.
 * Use `create(OldAssessmentV3Schema)` to create a new message.
 */
export const OldAssessmentV3Schema: GenMessage<OldAssessmentV3> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 55);

/**
 * @generated from message inventory.v1.AssessmentFinding
 */
export type AssessmentFinding = Message<"inventory.v1.AssessmentFinding"> & {
  /**
   * @generated from field: inventory.v1.GetFindingResponse finding = 1;
   */
  finding?: GetFindingResponse;

  /**
   * @generated from field: inventory.v1.GetFindingTimelineResponse timeline = 2;
   */
  timeline?: GetFindingTimelineResponse;
};

/**
 * Describes the message inventory.v1.AssessmentFinding.
 * Use `create(AssessmentFindingSchema)` to create a new message.
 */
export const AssessmentFindingSchema: GenMessage<AssessmentFinding> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 56);

/**
 * AssessmentSignal is a snapshot of a signal relevant to this assessment.
 * Per ENG-2978: status and severity are intentionally NOT included here —
 * they describe live alert state, not the assessment's immutable view of
 * the signal. `detail` is the SignalDetail snapshot captured at finalize
 * time so the read-only past-assessment view can render description, risk,
 * markdown, document quotes and control ids without firing GetSignal.
 *
 * @generated from message inventory.v1.AssessmentSignal
 */
export type AssessmentSignal = Message<"inventory.v1.AssessmentSignal"> & {
  /**
   * @generated from field: string signal_id = 1;
   */
  signalId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string subtitle = 3;
   */
  subtitle: string;

  /**
   * @generated from field: inventory.v1.SignalType signal_type = 4;
   */
  signalType: SignalType;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: inventory.v1.SignalDetail detail = 6;
   */
  detail?: SignalDetail;

  /**
   * @generated from field: google.protobuf.Timestamp detection_time = 7;
   */
  detectionTime?: Timestamp;

  /**
   * @generated from field: inventory.v1.CompanySummary company_summary = 8;
   */
  companySummary?: CompanySummary;
};

/**
 * Describes the message inventory.v1.AssessmentSignal.
 * Use `create(AssessmentSignalSchema)` to create a new message.
 */
export const AssessmentSignalSchema: GenMessage<AssessmentSignal> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 57);

/**
 * @generated from message inventory.v1.AssessmentControl
 */
export type AssessmentControl = Message<"inventory.v1.AssessmentControl"> & {
  /**
   * @generated from field: inventory.v1.GetControlResponse control = 1;
   */
  control?: GetControlResponse;

  /**
   * @generated from field: inventory.v1.GetControlTimelineResponse timeline = 2;
   */
  timeline?: GetControlTimelineResponse;
};

/**
 * Describes the message inventory.v1.AssessmentControl.
 * Use `create(AssessmentControlSchema)` to create a new message.
 */
export const AssessmentControlSchema: GenMessage<AssessmentControl> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 58);

/**
 * @generated from message inventory.v1.GetRoomByAssessmentIdRequest
 */
export type GetRoomByAssessmentIdRequest = Message<"inventory.v1.GetRoomByAssessmentIdRequest"> & {
  /**
   * @generated from field: string assessment_id = 1;
   */
  assessmentId: string;
};

/**
 * Describes the message inventory.v1.GetRoomByAssessmentIdRequest.
 * Use `create(GetRoomByAssessmentIdRequestSchema)` to create a new message.
 */
export const GetRoomByAssessmentIdRequestSchema: GenMessage<GetRoomByAssessmentIdRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 59);

/**
 * @generated from message inventory.v1.GetRoomByAssessmentIdResponse
 */
export type GetRoomByAssessmentIdResponse = Message<"inventory.v1.GetRoomByAssessmentIdResponse"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;
};

/**
 * Describes the message inventory.v1.GetRoomByAssessmentIdResponse.
 * Use `create(GetRoomByAssessmentIdResponseSchema)` to create a new message.
 */
export const GetRoomByAssessmentIdResponseSchema: GenMessage<GetRoomByAssessmentIdResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 60);

/**
 * @generated from message inventory.v1.GetTokenRequest
 */
export type GetTokenRequest = Message<"inventory.v1.GetTokenRequest"> & {
};

/**
 * Describes the message inventory.v1.GetTokenRequest.
 * Use `create(GetTokenRequestSchema)` to create a new message.
 */
export const GetTokenRequestSchema: GenMessage<GetTokenRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 61);

/**
 * @generated from message inventory.v1.GetTokenResponse
 */
export type GetTokenResponse = Message<"inventory.v1.GetTokenResponse"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message inventory.v1.GetTokenResponse.
 * Use `create(GetTokenResponseSchema)` to create a new message.
 */
export const GetTokenResponseSchema: GenMessage<GetTokenResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 62);

/**
 * NOTE: This patch ensures compatibility with assessments using legacy control definitions.
 * TODO: Remove after inventory model types are properly versioned and no longer depend on inventory/v1.
 *
 * @generated from message inventory.v1.OldAssessmentV1
 */
export type OldAssessmentV1 = Message<"inventory.v1.OldAssessmentV1"> & {
  /**
   * @generated from field: inventory.v1.AssessmentInfo info = 1;
   */
  info?: AssessmentInfo;

  /**
   * @generated from field: repeated inventory.v1.AssessmentFinding assessment_findings = 2;
   */
  assessmentFindings: AssessmentFinding[];

  /**
   * @generated from field: repeated inventory.v1.OldAssessmentControlV1 assessment_controls = 3;
   */
  assessmentControls: OldAssessmentControlV1[];

  /**
   * @generated from field: repeated artifacts.v1.Artifact artifacts = 4;
   */
  artifacts: Artifact[];

  /**
   * @generated from field: repeated inventory.v1.InherentRiskGroup inherent_risk_groups = 5;
   */
  inherentRiskGroups: InherentRiskGroup[];
};

/**
 * Describes the message inventory.v1.OldAssessmentV1.
 * Use `create(OldAssessmentV1Schema)` to create a new message.
 */
export const OldAssessmentV1Schema: GenMessage<OldAssessmentV1> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 63);

/**
 * NOTE: This patch ensures compatibility with assessments using legacy control definitions.
 * TODO: Remove after inventory model types are properly versioned and no longer depend on inventory/v1.
 *
 * @generated from message inventory.v1.OldAssessmentControlV1
 */
export type OldAssessmentControlV1 = Message<"inventory.v1.OldAssessmentControlV1"> & {
  /**
   * @generated from field: inventory.v1.OldGetControlResponseV1 control = 1;
   */
  control?: OldGetControlResponseV1;

  /**
   * @generated from field: inventory.v1.GetControlTimelineResponse timeline = 2;
   */
  timeline?: GetControlTimelineResponse;
};

/**
 * Describes the message inventory.v1.OldAssessmentControlV1.
 * Use `create(OldAssessmentControlV1Schema)` to create a new message.
 */
export const OldAssessmentControlV1Schema: GenMessage<OldAssessmentControlV1> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 64);

/**
 * @generated from message inventory.v1.OldAssessmentV2
 */
export type OldAssessmentV2 = Message<"inventory.v1.OldAssessmentV2"> & {
  /**
   * @generated from field: inventory.v1.AssessmentInfo info = 1;
   */
  info?: AssessmentInfo;

  /**
   * @generated from field: repeated inventory.v1.AssessmentFinding assessment_findings = 2;
   */
  assessmentFindings: AssessmentFinding[];

  /**
   * @generated from field: repeated inventory.v1.OldAssessmentControlV2 assessment_controls = 3;
   */
  assessmentControls: OldAssessmentControlV2[];

  /**
   * @generated from field: repeated artifacts.v1.Artifact artifacts = 4;
   */
  artifacts: Artifact[];

  /**
   * @generated from field: repeated inventory.v1.InherentRiskGroup inherent_risk_groups = 5;
   */
  inherentRiskGroups: InherentRiskGroup[];
};

/**
 * Describes the message inventory.v1.OldAssessmentV2.
 * Use `create(OldAssessmentV2Schema)` to create a new message.
 */
export const OldAssessmentV2Schema: GenMessage<OldAssessmentV2> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 65);

/**
 * @generated from message inventory.v1.OldAssessmentControlV2
 */
export type OldAssessmentControlV2 = Message<"inventory.v1.OldAssessmentControlV2"> & {
  /**
   * @generated from field: inventory.v1.OldGetControlResponseV2 control = 1;
   */
  control?: OldGetControlResponseV2;

  /**
   * @generated from field: inventory.v1.GetControlTimelineResponse timeline = 2;
   */
  timeline?: GetControlTimelineResponse;
};

/**
 * Describes the message inventory.v1.OldAssessmentControlV2.
 * Use `create(OldAssessmentControlV2Schema)` to create a new message.
 */
export const OldAssessmentControlV2Schema: GenMessage<OldAssessmentControlV2> = /*@__PURE__*/
  messageDesc(file_inventory_v1_assessment_service, 66);

/**
 * @generated from enum inventory.v1.ProjectAttributeChangeType
 */
export enum ProjectAttributeChangeType {
  /**
   * @generated from enum value: PROJECT_ATTRIBUTE_CHANGE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROJECT_ATTRIBUTE_CHANGE_TYPE_ADD = 1;
   */
  ADD = 1,

  /**
   * @generated from enum value: PROJECT_ATTRIBUTE_CHANGE_TYPE_REMOVE = 2;
   */
  REMOVE = 2,
}

/**
 * Describes the enum inventory.v1.ProjectAttributeChangeType.
 */
export const ProjectAttributeChangeTypeSchema: GenEnum<ProjectAttributeChangeType> = /*@__PURE__*/
  enumDesc(file_inventory_v1_assessment_service, 0);

/**
 * @generated from service inventory.v1.AssessmentService
 */
export const AssessmentService: GenService<{
  /**
   * @generated from rpc inventory.v1.AssessmentService.StartAssessment
   */
  startAssessment: {
    methodKind: "unary";
    input: typeof StartAssessmentRequestSchema;
    output: typeof StartAssessmentResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentService.FinalizeAssessment
   */
  finalizeAssessment: {
    methodKind: "unary";
    input: typeof FinalizeAssessmentRequestSchema;
    output: typeof FinalizeAssessmentResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentService.ListAssessments
   */
  listAssessments: {
    methodKind: "unary";
    input: typeof ListAssessmentsRequestSchema;
    output: typeof ListAssessmentsResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentService.ListOngoingAssessments
   */
  listOngoingAssessments: {
    methodKind: "unary";
    input: typeof ListOngoingAssessmentsRequestSchema;
    output: typeof ListOngoingAssessmentsResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentService.GetOngoingAssessment
   */
  getOngoingAssessment: {
    methodKind: "unary";
    input: typeof GetOngoingAssessmentRequestSchema;
    output: typeof GetOngoingAssessmentResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentService.GetAssessment
   */
  getAssessment: {
    methodKind: "unary";
    input: typeof GetAssessmentRequestSchema;
    output: typeof GetAssessmentResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentService.GetRoomByAssessmentId
   */
  getRoomByAssessmentId: {
    methodKind: "unary";
    input: typeof GetRoomByAssessmentIdRequestSchema;
    output: typeof GetRoomByAssessmentIdResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentService.GetToken
   */
  getToken: {
    methodKind: "unary";
    input: typeof GetTokenRequestSchema;
    output: typeof GetTokenResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentService.ListProjects
   */
  listProjects: {
    methodKind: "unary";
    input: typeof ListProjectsRequestSchema;
    output: typeof ListProjectsResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentService.GetProject
   */
  getProject: {
    methodKind: "unary";
    input: typeof GetProjectRequestSchema;
    output: typeof GetProjectResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentService.ListAssessmentCadenceSettings
   */
  listAssessmentCadenceSettings: {
    methodKind: "unary";
    input: typeof ListAssessmentCadenceSettingsRequestSchema;
    output: typeof ListAssessmentCadenceSettingsResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentService.GetAssessmentNotesYdoc
   */
  getAssessmentNotesYdoc: {
    methodKind: "unary";
    input: typeof GetAssessmentNotesYdocRequestSchema;
    output: typeof GetAssessmentNotesYdocResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentService.SetAssessmentCadenceSetting
   */
  setAssessmentCadenceSetting: {
    methodKind: "unary";
    input: typeof SetAssessmentCadenceSettingRequestSchema;
    output: typeof SetAssessmentCadenceSettingResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentService.ListAssessmentScoreLabels
   */
  listAssessmentScoreLabels: {
    methodKind: "unary";
    input: typeof ListAssessmentScoreLabelsRequestSchema;
    output: typeof ListAssessmentScoreLabelsResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentService.SetAssessmentScoreLabels
   */
  setAssessmentScoreLabels: {
    methodKind: "unary";
    input: typeof SetAssessmentScoreLabelsRequestSchema;
    output: typeof SetAssessmentScoreLabelsResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentService.DeleteAssessmentScoreLabels
   */
  deleteAssessmentScoreLabels: {
    methodKind: "unary";
    input: typeof DeleteAssessmentScoreLabelsRequestSchema;
    output: typeof DeleteAssessmentScoreLabelsResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentService.CreateProject
   */
  createProject: {
    methodKind: "unary";
    input: typeof CreateProjectRequestSchema;
    output: typeof CreateProjectResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentService.DeleteProject
   */
  deleteProject: {
    methodKind: "unary";
    input: typeof DeleteProjectRequestSchema;
    output: typeof DeleteProjectResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentService.UpdateProjectName
   */
  updateProjectName: {
    methodKind: "unary";
    input: typeof UpdateProjectNameRequestSchema;
    output: typeof UpdateProjectNameResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentService.SetProjectMember
   */
  setProjectMember: {
    methodKind: "unary";
    input: typeof SetProjectMemberRequestSchema;
    output: typeof SetProjectMemberResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentService.SetProjectControlScope
   */
  setProjectControlScope: {
    methodKind: "unary";
    input: typeof SetProjectControlScopeRequestSchema;
    output: typeof SetProjectControlScopeResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentService.UpdateAssessmentDueDate
   */
  updateAssessmentDueDate: {
    methodKind: "unary";
    input: typeof UpdateAssessmentDueDateRequestSchema;
    output: typeof UpdateAssessmentDueDateResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentService.DeleteOngoingAssessment
   */
  deleteOngoingAssessment: {
    methodKind: "unary";
    input: typeof DeleteOngoingAssessmentRequestSchema;
    output: typeof DeleteOngoingAssessmentResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentService.AddOngoingAssessmentAssignee
   */
  addOngoingAssessmentAssignee: {
    methodKind: "unary";
    input: typeof AddOngoingAssessmentAssigneeRequestSchema;
    output: typeof AddOngoingAssessmentAssigneeResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.AssessmentService.RemoveOngoingAssessmentAssignee
   */
  removeOngoingAssessmentAssignee: {
    methodKind: "unary";
    input: typeof RemoveOngoingAssessmentAssigneeRequestSchema;
    output: typeof RemoveOngoingAssessmentAssigneeResponseSchema;
  },
  /**
   * SubmitAssessmentForApproval moves an ongoing assessment from IN_PROGRESS to
   * AWAITING_APPROVAL, records the caller as concluded_by, and triggers report
   * generation.
   *
   * @generated from rpc inventory.v1.AssessmentService.SubmitAssessmentForApproval
   */
  submitAssessmentForApproval: {
    methodKind: "unary";
    input: typeof SubmitAssessmentForApprovalRequestSchema;
    output: typeof SubmitAssessmentForApprovalResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_inventory_v1_assessment_service, 0);

